// Mục "Nâng cao (dành cho kỹ thuật)": sửa thẳng JSON cấu hình, chỉ để chạm khoá lạ không có ô riêng.
import { useEffect, useState } from "react";
import { Alert, Button, Collapse, Input, message } from "antd";

export default function XuConfigAdvancedJson({ config, onApply }) {
    const [text, setText] = useState("");
    useEffect(() => {
        setText(JSON.stringify(config, null, 2));
    }, [config]);

    const apply = () => {
        try {
            const parsed = JSON.parse(text);
            if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) throw new Error("not object");
            onApply(parsed);
            message.success("Đã áp dụng JSON lên các ô ở trên (chưa lưu)");
        } catch {
            message.error("Nội dung không phải JSON hợp lệ");
        }
    };

    return (
        <Collapse
            items={[
                {
                    key: "json",
                    label: "Nâng cao (dành cho kỹ thuật)",
                    children: (
                        <div>
                            <Alert className="mb-2" type="warning" showIcon message="Người không biết lập trình không cần mở mục này. Bấm “Áp dụng JSON” chỉ cập nhật màn hình, vẫn phải bấm Lưu cấu hình." />
                            <Input.TextArea value={text} onChange={(e) => setText(e.target.value)} autoSize={{ minRows: 10, maxRows: 30 }} style={{ fontFamily: "monospace", fontSize: 13 }} />
                            <Button className="mt-2" onClick={apply}>Áp dụng JSON</Button>
                        </div>
                    ),
                },
            ]}
        />
    );
}
